import React, { useEffect, useState } from 'react';
import './NetflixTitle.css';
import netflixSound from './netflix-sound.mp3';
import { useNavigate } from 'react-router-dom';
import logoImage from '../src/images/logo-5.png'; // Update with the path to your logo

const NetflixTitle = () => {
  const [isClicked, setIsClicked] = useState(false);
  const navigate = useNavigate();

  const handlePlaySound = () => {
    const audio = new Audio(netflixSound);
    audio.play().catch(error => console.error("Audio play error:", error));
    setIsClicked(true); // Starts animation after clicking
  };

  useEffect(() => {
    // Detect Lighthouse and common search engine crawlers/bots to bypass intro
    const userAgent = navigator.userAgent || '';
    const isBot = /bot|google|baidu|bing|msn|duckduckgo|teoma|slurp|yandex|lighthouse|chrome-lighthouse/i.test(userAgent) || navigator.webdriver;

    if (isBot) return;

    if (isClicked) {
      // User clicked - proceed with the 4-second sound/zoom animation transition
      const timer = setTimeout(() => {
        navigate('/browse');
      }, 4000);
      return () => clearTimeout(timer);
    } else {
      // User hasn't clicked - set a fallback timer to auto-transition after 6 seconds
      const autoTransitionTimer = setTimeout(() => {
        navigate('/browse');
      }, 6000);
      return () => clearTimeout(autoTransitionTimer);
    }
  }, [isClicked, navigate]);

  return (
    <div className="netflix-container" onClick={handlePlaySound}>
      {/* Visually hidden H1 for SEO without affecting design */}
      <h1 className="sr-only">Gourav | Freelance Software & Web Developer Portfolio</h1>
      <img 
        src={logoImage} 
        alt="Custom Logo" 
        className={`netflix-logo ${isClicked ? 'animate' : ''}`} 
      />
      {!isClicked && (
        <div className="sound-hint">
          <svg className="audio-wave" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
            <path className="wave-line-1" d="M15.54 8.46a5 5 0 0 1 0 7.07"></path>
            <path className="wave-line-2" d="M19.07 4.93a10 10 0 0 1 0 14.14"></path>
          </svg>
          <span className="hint-text"> Click anywhere to Start</span>
        </div>
      )}
    </div>
  );
};

export default NetflixTitle;
